import { __decorate, __param } from "tslib";
import { IInstantiationService, IInstantiationHookPoint } from './instantiation';
import { InstantiationHook } from './instantiation-hook';
/**
 * 用于包裹非单例模块
 */
let TransientServiceHolder = class TransientServiceHolder {
    constructor(params = [], instantiationService) {
        this.instantiationService = instantiationService;
        this.instantiationHook = new InstantiationHook();
        this.params = params;
    }
    /**
     * 获取模块实例时支持传递参数
     * @param params
     */
    getNewInstance(params) {
        const allParams = params || (this.params.length > 0 ? this.params : []);
        const ctor = this.getCtor();
        const instance = this.instantiationService.createInstance(ctor, 
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ...allParams);
        this.executeHooks(instance, IInstantiationHookPoint.POST_CONSTRUCTOR);
        return instance;
    }
    addHook(hookPoint, callback) {
        this.instantiationHook.addHook(hookPoint, callback);
    }
    executeHooks(instance, point) {
        this.instantiationHook.executeHooks(instance, point);
    }
};
TransientServiceHolder = __decorate([
    __param(1, IInstantiationService)
], TransientServiceHolder);
export { TransientServiceHolder };
/**
 * 提供一个helper函数，将普通构造函数包装成非单例模块Holder
 * @param ctor
 */
export function transientService(ctor) {
    return class extends TransientServiceHolder {
        getCtor() {
            return ctor;
        }
    };
}
//# sourceMappingURL=transient-service.js.map